 "use client";
 import React, { Suspense } from "react"; 
import TableBookingsPage from "./TableBookings";
 export default function page() {
   return (
     <Suspense
       fallback={
         <div className="min-h-screen flex items-center justify-center">
           Loading...
         </div>
       }
     >
       <div>
         <TableBookingsPage />
       </div>
     </Suspense>
   );
 }